<template>
  <div
    id="loginAdmin"
    class="app flex-row align-items-center"
    style="background-color: #e4e5e6"
  >
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-4">
          <div class="card-group">
            <div class="card p-4">
              <div class="card-body">
                <div class="mb-3 text-center logo"></div>
                <div class="contentLogo"></div>
                <form id="loginForm" action="#">
                  <p class="text-muted" data-language="SignIn"></p>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="icon-user"></i>
                      </span>
                    </div>
                    <input
                      id="loginUsername"
                      name="loginUsername"
                      class="form-control"
                      type="text"
                      :value="username"
                      :placeholder="usernamePlaceholder"
                    />
                  </div>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="icon-lock"></i>
                      </span>
                    </div>
                    <input
                      type="password"
                      id="loginPassword"
                      name="loginPassword"
                      class="form-control"
                      :value="password"
                      :placeholder="passwordPlaceholder"
                    />
                  </div>
                  <label
                    id="loginPasswordError"
                    class="is-invalid"
                    style="display:none;"
                  ></label>
                  <div class="row input-group mb-2">
                    <div class="col-12">
                      <input
                        type="checkbox"
                        id="chkSaveLogin"
                        v-model="checkedRememberMe"
                      />&nbsp;
                      <label>{{ rememberMe }}</label>
                    </div>
                  </div>
                  <div class="row input-group mb-2">
                    <div class="col-12">
                      <button
                        type="submit"
                        id="btnLogin"
                        class="btn btn-primary px-4"
                      >
                        {{ login }}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "adminLogin",
  computed: {
    usernamePlaceholder: function () {
      if(!functionHelpers.isValued(dictionaryHelpers.getDictionary("Username"))){
        return "Username";
      }else{
        return dictionaryHelpers.getDictionary("Username"); 
      }
    },
    passwordPlaceholder: function () {
      if(!functionHelpers.isValued(dictionaryHelpers.getDictionary("Password"))){
        return "Password";
      }else{
        return dictionaryHelpers.getDictionary("Password");
      }
    },
    rememberMe: function () {
      if(!functionHelpers.isValued(dictionaryHelpers.getDictionary("RememberMe"))){
        return "Resta connesso";
      }else{
        return dictionaryHelpers.getDictionary("RememberMe");
      }
    },
    login: function () {
      if(!functionHelpers.isValued(dictionaryHelpers.getDictionary("Login"))){
        return "Login";
      }else{
        return dictionaryHelpers.getDictionary("Login");
      }
    }
  },
  created: function () {
    
    if (functionHelpers.isValued(storageData.sCredetial())) {
      var credentials = storageData.sCredetial();
      this.username = credentials.username;
      this.password = credentials.password;
      this.checkedRememberMe = true;
    } else {
      this.username = "";
      this.password = "";
      this.checkedRememberMe = false;
    }
  },
  mounted() {
    var rulesValidation = {
      loginUsername: { required: true,minlength: 1 },
      loginPassword: { required: true,minlength: 1 }
    };

    validationHelpers.validate(
      "#loginForm",
      rulesValidation,
      loginHelpers.login
    );
  },
  methods: {
    doLogin: function () {
      if (validationHelpers.isValid("#loginForm")) {
        loginHelpers.login();
      }
    }
  }
};
</script>

<style>
  .app {
    display: flex;
    min-height: 100vh;
  }
</style>

